import React, {Component, Fragment} from 'react'
import {Row, Col} from 'antd'
import moment from 'moment';
import 'moment/locale/zh-cn';
import {PLAN_DELIVERY_TYPE} from "../../utills/constants";

moment.locale('zh-cn');
export default class DeliveryView extends Component {
    render() {
        const {checkDt, entryZone, entryStation, deliveryType} = this.props;
        return (<Row className='box-info'>
                <Col span={8} xs={24} md={8}>
                    <span className='label'>查验时间 : </span>
                    <span>{checkDt}</span>
                </Col>
                {PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                    <Fragment>
                        <Col span={8} xs={24} md={8}>
                            <span className='label'>入区时间 : </span>
                            <span>{entryZone}</span>
                        </Col>
                        <Col span={8} xs={24} md={8}>
                            <span className='label'>入站时间 : </span>
                            <span>{entryStation}</span>
                        </Col>
                    </Fragment> : null}
            </Row>
        )
    }
}